import React, { Component, Fragment } from 'react';
import { Row, Col, Label } from 'reactstrap';
import { AvGroup, AvField, AvInput } from 'availity-reactstrap-validation';
import i18n from '../../../../../i18next';

class SizeAndCookTimeFields extends Component {

    negativeDecimalsValidation(e) {
        let inputKeyCode = e.keyCode ? e.keyCode : e.which;

        if (inputKeyCode != null) {
            if (inputKeyCode == 43 || inputKeyCode == 45 || inputKeyCode == 69
                || inputKeyCode == 101) e.preventDefault();
        }
    }

    render() {
        return (
            <Fragment>
                <Row>
                    <Col xs={12} sm={6}>
                        <AvGroup>
                            <AvField type="input" name="sizeName" label={i18n.t('common:form.sizeName')}
                                value={this.props.sizeName}
                                onChange={this.props.changeState}
                                required={false} />
                        </AvGroup>
                    </Col>
                    <Col xs={12} sm={6}>
                        <AvGroup>
                            <AvField type="number" name="sizePriority" label={i18n.t('common:form.sizePriority')} min={-1}
                                validate={{ min: { value: 0 } }}
                                value={this.props.sizePriority}
                                onChange={this.props.changeState}
                                required={false}
                                errorMessage={i18n.t('common:validations.invalid')} />
                        </AvGroup>
                    </Col>
                </Row>
                <Row>
                    <Col xs={12} sm={6} hidden={this.props.isCookTimeHidden}>
                        <AvGroup>
                            <Label for="cookTime" style={{ lineHeight: 0.9 }}>{i18n.t('common:form.cookTime')}<br /><span style={{ fontSize: 11 }}>({i18n.t('screens:preparationTimes.minutes')})</span></Label>
                            <AvInput type="number" name="cookTime"
                                min="0"
                                onKeyPress={(e) => this.negativeDecimalsValidation(e)}
                                step="1"
                                required={false}
                                value={this.props.cookTime}
                                onChange={this.props.changeFreeToppingsCountState}
                            />
                        </AvGroup>
                    </Col>
                </Row>
            </Fragment>
        )
    }
}

export default SizeAndCookTimeFields;


// WEBPACK FOOTER //
// ./src/components/restaurants/posmenu/common/additionalInformation/SizeAndCookTimeFields.js